import style from './index.less';

export default () => {
    return (
        <div className={style.qrcode}>
            <div>使用<span className="em">百度智能云APP/百度APP</span>扫码登录</div>
            <div style={{marginTop: 4}}>账号与百度APP、贴吧、网盘等产品通用</div>
        </div>
    );
};
